import { createSlice } from '@reduxjs/toolkit';
import { t_billing_process, hospital_visit_and_links_results, t_medical_institution } from 'types';
import {
  getFacilityByUser,
  getHospitals,
  getOptionInvoiceHeader,
  registerBillReceive,
  updateStatusOfClinic,
} from './thunks';

interface InitialState {
  facility: t_medical_institution | null;
  loadH2: boolean;
  invoiceH?: t_billing_process;
  field_edit: any[];
  hospitals: {
    items: hospital_visit_and_links_results[];
    totalItems: number;
  };
  fieldHospital: any[];
  optionH3: any[];
}

const initialState: InitialState = {
  facility: null,
  loadH2: false,
  field_edit: [],
  hospitals: {
    items: [],
    totalItems: 0,
  },
  fieldHospital: [],
  optionH3: [],
};

const slices = createSlice({
  name: 'receiving',
  initialState,
  reducers: {
    openLoadH2(state) {
      return { ...state, loadH2: true };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFacilityByUser.fulfilled, (state, action) => ({ ...state, facility: action.payload }));
    builder.addCase(registerBillReceive.fulfilled, (state, action) => ({
      ...state,
      invoiceH: action.payload.item,
      field_edit: action.payload.field_edit,
    }));
    builder.addCase(getHospitals.fulfilled, (state, action) => ({
      ...state,
      hospitals: action.payload.hospitals,
      fieldHospital: action.payload.fieldHospital,
    }));
    builder.addCase(updateStatusOfClinic.fulfilled, (state, action) => ({ ...state, invoiceH: action.payload }));
    builder.addCase(getOptionInvoiceHeader.fulfilled, (state, action) => ({ ...state, optionH3: action.payload }));
  },
});

export const { openLoadH2 } = slices.actions;
export default slices.reducer;
